import * as Ably from "ably";
import { useEffect } from "react";

export const ablyClient = new Ably.Realtime({
  key: "JVuVQQ.pUFznQ:pkdoUR4_imyHLX7goUVW5HLTEHaPgK0Gui6GMWD24G0",
  clientId: "ably-chat",
});

export async function sendAblyMessage(channelName, senderId, receiverId, text) {
  try {
    const channel = ablyClient.channels.get(channelName);
    await channel.publish(channelName, {
      senderId,
      receiverId,
      text,
    });
    // console.log(`Message sent from ${senderId} to ${receiverId}`);
  } catch (err) {
    console.error("Ably message send failed:", err);
  }
}

export async function sendCashout(channelName, senderId, receiverId, text) {
  try {
    const channel = ablyClient.channels.get(channelName);
    await channel.publish("private-cash", {
      senderId,
      receiverId,
      text,
    });
    // console.log(`Message sent from ${senderId} to ${receiverId}`);
  } catch (err) {
    console.error("Ably message send failed:", err);
  }
}

async function addCreditChannel(
  channelName,
  senderId,
  receiverId,
  text
) {
  try {
    const channel = ablyClient.channels.get(channelName);
    await channel.publish("private-credit", {
      senderId,
      receiverId,
      text,
    });
    // console.log(`Message sent from ${senderId} to ${receiverId}`);
  } catch (err) {
    console.error("Ably message send failed:", err);
  }
}

async function RedeemChannel(channelName, senderId, receiverId, text) {
  try {
    const channel = ablyClient.channels.get(channelName);
    await channel.publish("private-redeem", {
      senderId,
      receiverId,
      text,
    });
    // console.log(`Message sent from ${senderId} to ${receiverId}`);
  } catch (err) {
    console.error("Ably message send failed:", err);
  }
}

export async function ResetPasswordChannel(
  channelName,
  senderId,
  receiverId,
  text
) {
  try {
    const channel = ablyClient.channels.get(channelName);
    await channel.publish("private-reset", {
      senderId,
      receiverId,
      text,
    });
    // console.log(`Message sent from ${senderId} to ${receiverId}`);
  } catch (err) {
    console.error("Ably message send failed:", err);
  }
}

async function WatchChannel(channelName, payload) {
  try {
    const channel = ablyClient.channels.get(channelName);
    await channel.publish("userslists", payload);
    // console.log(`Message sent from ${senderId} to ${receiverId}`);
  } catch (err) {
    console.error("Ably message send failed:", err);
  }
}
